import Now from './Now';
import Start from './Start';
import Stop from './Stop';

export default {
    Now,
    Start,
    Stop,
};
